module.exports = __webpack_public_path__ + "img/hosp.056a89cd.png";